import { css } from "@emotion/react";
import styled from "@emotion/styled";

import { BaseLink } from "shared/components/common/base-link";
import { theme } from "shared/lib/styles";

import type { HeaderFeaturesLogoTextLinkVariant } from "scmp-app/components/header/features/logo-text-link";
import { ResponsiveContainer } from "scmp-app/components/header/features/styles";
import IconLogoText from "scmp-app/components/header/icon-logo-with-text.svg";

export type HeaderFeaturesLogoTextLinkProps = {
  $variant?: HeaderFeaturesLogoTextLinkVariant;
};
export const Container = styled(ResponsiveContainer)<HeaderFeaturesLogoTextLinkProps>`
  ${({ $variant }) =>
    $variant === "centered" &&
    css`
      position: absolute;
      inset-block-start: 50%;
      inset-inline-start: 50%;

      transform: translate(-50%, -50%);
    `}
`;

export const StyledLogoLink = styled(BaseLink)`
  display: flex;
  flex-flow: row nowrap;
  justify-content: center;
  align-items: center;
`;

export const StyledScmpLogoText = styled(IconLogoText)`
  inline-size: 207px;
  block-size: 22px;

  ${theme.breakpoints.up("tablet")} {
    inline-size: 330px;
    block-size: 34.3px;
  }

  ${theme.breakpoints.up("desktop")} {
    inline-size: 481px;
    block-size: 50px;
  }
`;
